<template>
  <div :class="`form-element-viewer ${type}-viewer`">
    <v-btn
      v-if="value && value.file_url"
      block
      target="_blank"
      :href="value.file_url"
      style="max-width: 100%"
    >
      {{ value.name }}
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: [String, Object], default: null },
    type: { type: String, required: true }
  }
};
</script>
